/**
 * Theme Store
 *
 * Persists the active UI theme (light / dark HMI / legacy) to localStorage
 * and exposes a setter. Reading `body[data-theme]` should match this store at
 * all times — the <ThemeProvider> keeps them in sync.
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { ThemeMode } from '@/theme/muiThemes';

interface ThemeState {
  theme: ThemeMode;
  setTheme: (theme: ThemeMode) => void;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      theme: 'dark',
      setTheme: (theme) => set({ theme }),
    }),
    {
      name: 'vsmr.theme',
    }
  )
);
